import { createSlice } from "@reduxjs/toolkit";

const initialState: any = {
  students: [],
  instructors: [],
  status: "idle",
  error: null,
};

export const usersSlice = createSlice({
  name: "user",
  initialState,
  reducers: {},
  extraReducers: (builder) => {},
});

export default usersSlice.reducer;
